import { Injectable } from "@angular/core";
import { el, mount } from "src/app/support/dom";
import { Subject } from "rxjs";
import { PlatformType } from "src/app/common/platform-type";
import { UAParser } from "ua-parser-js";

export type VisibilityState = "visible" | "hidden";

@Injectable()
export class PlatformService {
  pageVisibility$: Subject<VisibilityState> = new Subject<VisibilityState>();

  constructor() {
    document.addEventListener("visibilitychange", () => {
      this.pageVisibility$.next(document.visibilityState);
    });
  }

  init(): void {
    switch (this.getType()) {
      case PlatformType.MOBILE: {
        document
          .querySelector("app-root")
          ?.classList.add("snt-platform-mobile");

        this.#injectBetaIndicator();
        break;
      }
      case PlatformType.DESKTOP: {
        document
          .querySelector("app-root")
          ?.classList.add("snt-platform-desktop");
        break;
      }
    }
  }

  #injectBetaIndicator(): void {
    const appLoaderImage = document.querySelector("#app-loader-image");
    if (!appLoaderImage) {
      return;
    }

    mount(
      appLoaderImage,
      el(
        "div",
        {
          class: "absolute flex flex-row",
          style: { top: "-24px", right: "-39px" }
        },
        [
          el("div", { class: "p-1 rounded-md bg-primary-900 text-white" }, [
            el("span", { class: "uppercase text-sm" }, "BETA")
          ])
        ]
      )
    );
  }

  getType(): PlatformType {
    const parser = new UAParser(navigator.userAgent);
    const device = parser.getDevice();

    return device.type === "mobile"
      ? PlatformType.MOBILE
      : PlatformType.DESKTOP;
  }

  getDeviceType(): "mobile" | "desktop" | "tablet" {
    const parser = new UAParser(navigator.userAgent);
    const device = parser.getDevice();

    switch (device.type) {
      case "mobile": {
        return "mobile";
      }
      case "tablet": {
        return "tablet";
      }
      default: {
        return "desktop";
      }
    }
  }

  isMobile(): boolean {
    return this.getType() === PlatformType.MOBILE;
  }

  isPageVisible(): boolean {
    return document.visibilityState === "visible";
  }

  isPageHidden(): boolean {
    return document.visibilityState !== "visible";
  }
}
